import { ref, computed } from 'vue'
import { MdTypography, MdButton, MdSpinner, MdIconFailed, MdIconDownload, MdDropdown, MdDropdownItem } from '@antiqua-dls/vue-components'
import FouMdDrawer from 'src/components/overlay/fou-md-drawer/index.vue'
import Accordion from 'src/components/accordion/index.vue'
import TextField from 'src/components/form/new-text-field/index.vue'
import FontDisplayStylesTable from 'src/pages/inventory-ingestion-hub/pages/components/font-display-styles-table/index.vue'
import NoResultImage from 'src/components/icons/lady-thinking-icon/no_result_image.svg'
import NoResultFound from 'src/components/general/no-result-found/index.vue'    
import dayjs from 'dayjs'
import DrawerLoading from 'src/pages/inventory-ingestion-hub/pages/components/drawer-loading-overview/index.vue'
import Notes from 'src/pages/inventory-ingestion-hub/pages/components/submit-drawer/components/notes/index.vue'
import IngestionLoader from 'src/pages/inventory-ingestion-hub/components/ingestion-loader/index.vue';
import ProgressCol from 'src/pages/inventory-ingestion-hub/components/agGridTable/components/customColumns/progessCol.vue';
import ProjectErrorImage from 'src/components/icons/robot-m-image/robot_m_image.svg'
import TransferProjectImage from 'src/components/icons/n-paint-image/n_paint_image.svg'
import { buildIngestionCSV } from 'src/utils/helper/misc'


export default {    
    name: 'SubmitDrawer',

    components: {
        MdTypography,
        MdButton,
        MdSpinner,
        FouMdDrawer,
        MdIconFailed,
        TextField,
        Accordion,
        FontDisplayStylesTable,
        NoResultFound,
        DrawerLoading,
        IngestionLoader,
        Notes,
        ProgressCol,
        MdIconDownload,
        MdDropdown,
        MdDropdownItem
    },

    props: {
        isOpen: {
            type: Boolean,
            default: false
        },
        ingestionData: {
            type: Object,
            default: () => ({})
        },
        ingestionSubmissionLoader: {    
            type: Boolean,
            default: false
        },
        reviewAPIinProgress: {
            type: Boolean,
            default: false
        },
        isLiveIngestion: {
            type: Boolean,
            default: false
        }
    },

    emits: ['close', 'submit-ingestion', 'download-submission'],

    setup(props, { emit }) {
        const activeTab = ref('overview')
        const familySearch = ref('')
        const showSpinner = ref(false)
        const showSubmissionDownloadDropdown = ref(false)
        const dropdownRef = ref(null);
        const filteredFamilies = computed(() => {
            if (!familySearch.value.trim()) {
                return props.ingestionData?.submissions || []
            }

            const searchTerm = familySearch.value.toLowerCase().trim()
            return (props.ingestionData?.submissions || []).filter(submission =>
                submission.familyName?.toLowerCase().includes(searchTerm)
            )
        })

        const formattedUpdatedDate = computed(() => {
            if (!props.ingestionData?.updatedAt) return ''
            return dayjs(props.ingestionData.updatedAt).format('MMM D, YYYY')
        })

        const familyNotes = computed(() => {
            const notes = []
            const submissions = props.ingestionData?.submissions || []
            submissions.forEach((sub) => {
                notes.push({ name: sub?.familyName, note: sub.revisionDetails?.userMetaData?.familyNotes && sub.revisionDetails?.userMetaData?.familyNotes[0]?.note })
            })
            return notes
        })

        // Methods
        const openTab = (tabName) => {
            if (props.reviewAPIinProgress) return;
            activeTab.value = tabName
        }

        const clearSearch = () => {
            familySearch.value = ''
        }
        const handleClose = () => {
            activeTab.value = 'overview'
            familySearch.value = ''
            emit('close')
        }

        const handleSubmit = () => {
            emit('submit-ingestion')
        }


        const handleDownloadCSV = () => {
            try {
                // Pass 'live' if isLiveIngestion is true, otherwise pass 'in_draft'
                const csvParam = props.isLiveIngestion ? 'live' : 'in_draft';
                const csvString = buildIngestionCSV(props.ingestionData, csvParam);
                const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
                const url = URL.createObjectURL(blob);
                const link = document.createElement('a');
                const projectName = props.ingestionData?.metadata?.projectName || 'inventory_ingestion';
                link.href = url;
                link.setAttribute('download', `${projectName}_report.csv`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                URL.revokeObjectURL(url);
            } catch (e) {
                console.error('Error downloading CSV:', e);
            }
        }

        const downloadSubmission = async (submissionId, type) => {
            const isImagePresent = props.ingestionData?.submissions?.some(submission =>
                (submission.submissionId === submissionId) &&
                submission.revisionDetails?.userMetaData?.imageSortorders?.some(imageSortorder =>
                    imageSortorder.imageIds && imageSortorder.imageIds.length > 0
                )
            )
            emit('download-submission', submissionId, type, isImagePresent)
            await dropdownRef.value.clearSelection();     
        }

        return {
            activeTab,
            openTab,
            handleClose,
            handleSubmit,
            handleDownloadCSV,
            familySearch,
            filteredFamilies,
            formattedUpdatedDate,
            clearSearch,
            NoResultImage,
            familyNotes,
            showSpinner,
            downloadSubmission,
            showSubmissionDownloadDropdown,
            dropdownRef,
            ProjectErrorImage,
            TransferProjectImage
        }
    }
}
